/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AdminWorkstreamImporterCreatedWorkstream = {
    row_index: number;
    id: number;
    name: string;
    kind: AdminWorkstreamImporterCreatedWorkstream.kind;
};

export namespace AdminWorkstreamImporterCreatedWorkstream {

    export enum kind {
        PARENT = 'parent',
        CHILD = 'child',
    }


}

